import { render, staticRenderFns } from "./TdkHandle.vue?vue&type=template&id=b34cda74&scoped=true&"
import script from "./TdkHandle.vue?vue&type=script&lang=js&"
export * from "./TdkHandle.vue?vue&type=script&lang=js&"
import style0 from "./TdkHandle.vue?vue&type=style&index=0&id=b34cda74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34cda74",
  null
  
)

export default component.exports